import React, { useContext, useEffect, useState } from 'react'
import { FaArrowDown, FaRegFileAlt } from 'react-icons/fa'
import { FiLink } from 'react-icons/fi'

import MomentUtils from '@date-io/moment'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment from 'moment'
import SelectPartnerModal from '../../components/SelectPartnerModal'
import ToastMessages from '../../components/ToastMessages'
import Context from '../../context'
import { getLoggedUser, isAuthenticated } from '../../services/auth'
import history from '../../services/history'

const { REACT_APP_IMAGES_URL } = process.env

function CouponsForm() {
  const { setUser } = useContext(Context)
  const [partner, setPartner] = useState({})
  const [fileName, setFineName] = useState('Inserir planilha')

  useEffect(() => {
    if (isAuthenticated) {
      setUser(getLoggedUser)
    } else {
      history.replace('/')
    }
  }, [])

  const fileUpload = e => {
    const files = Array.from(e.target.files)

    if (files.length > 0) {
      setFineName(files[0].name)
    }
  }

  return (
    <div className="container-fluid" style={{ marginTop: '20px' }}>
      <ToastMessages />
      <Context.Provider value={{ setPartner }}>
        <form
          className="clube-form"
          encType="multipart/form-data"
          onSubmit={e => {
            e.preventDefault()
          }}
        >
          <div className="row">
            {partner.logo ? (
              <div
                className="col-3 clube-coupons-add-area-parent d-flex justify-content-center item-click"
                data-toggle="modal"
                data-target="#selectPartnerModal"
              >
                <img
                  src={`${REACT_APP_IMAGES_URL}${partner.logo}`}
                  className="h-100 w-100"
                  alt={partner.fantasyName}
                />
              </div>
            ) : (
              <div className="col-3 clube-coupons-add-area-parent d-flex justify-content-center">
                <div
                  className="item-click clube-coupons-add-area d-flex justify-content-center align-items-center"
                  data-toggle="modal"
                  data-target="#selectPartnerModal"
                >
                  <p>SELECIONAR PARCEIRO OU EVENTO</p>
                </div>
              </div>
            )}

            <div className="col-9 d-flex justify-content-between flex-column">
              <div className="d-flex flex-row">
                <input
                  type="file"
                  name="files"
                  id="files"
                  hidden
                  multiple
                  accept=".xls,.xlsx,.csv"
                  onChange={e => fileUpload(e)}
                />
                <div className="flex-grow-1 clube-send" style={{ marginRight: '15px' }}>
                  <label
                    htmlFor="files"
                    className=" d-flex justify-content-start clube-send item-click"
                  >
                    <FaRegFileAlt className="clube-send-icon" />
                    <p className="clube-send-text d-flex flex-column justify-content-around">
                      {fileName}
                    </p>
                  </label>
                </div>

                <div className="flex-grow-3 clube-send clube-download-model-button">
                  <FaArrowDown />
                  <p>Baixar Modelo da Planilha</p>
                </div>
              </div>

              <div className="clube-send">
                <div
                  className=" d-flex justify-content-start clube-send item-click"
                  data-toggle="modal"
                  data-target="#addLinkModal"
                >
                  <FiLink className="clube-send-icon" />
                  <div className="d-flex justify-content-between w-100">
                    <p className="clube-send-text d-flex flex-column justify-content-around">
                      Inserir código
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <h4 className="coupons-h4">Validade do Cupom</h4>
          <div className="row">
            <div className="col-6 d-flex flex-row justify-content-between">
              <div style={{ padding: '5px' }}>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                  <KeyboardDatePicker
                    margin="normal"
                    id="dateStart"
                    label="Data de inicio"
                    format="DD/MM/YYYY"
                    minDate={new Date()}
                    // value={date}
                    // onChange={handleChangeDate}
                    KeyboardButtonProps={{
                      'aria-label': 'Alterar Dia'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
              <div style={{ padding: '5px' }}>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale="pt-br">
                  <KeyboardDatePicker
                    margin="normal"
                    id="dateEnd"
                    label="Data de fim"
                    format="DD/MM/YYYY"
                    minDate={new Date()}
                    // value={date}
                    // onChange={handleChangeDate}
                    KeyboardButtonProps={{
                      'aria-label': 'Alterar Dia'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </div>
            </div>

            <div className="col-6 d-flex flex-row align-items-center">
              <div className="form-check mb-2 mr-sm-2">
                <input className="form-check-input" type="checkbox" id="permanent" />
                <label className="form-check-label" htmlFor="permanent">
                  Permanente
                </label>
              </div>
            </div>
          </div>

          <h4 className="coupons-h4">Possui quantidade de resgate por usuário?</h4>
          <div className="row" style={{ marginLeft: '10px', marginTop: '20px' }}>
            <div className="col-9 d-flex flex-row">
              <div className="flex-grow-2" style={{ marginRight: '15px' }}>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="hasLimitYes"
                    name="hasLimit"
                    className="custom-control-input"
                  />
                  <label className="custom-control-label" htmlFor="hasLimitYes">
                    Sim
                  </label>
                </div>
                <div className="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    id="hasLimitNo"
                    name="hasLimit"
                    className="custom-control-input"
                  />
                  <label className="custom-control-label" htmlFor="hasLimitNo">
                    Não
                  </label>
                </div>
              </div>

              <div className="form-group flex-grow-1">
                <input
                  type="number"
                  className="form-control"
                  id="userLimit"
                  placeholder="Quantidade"
                />
              </div>
            </div>

            <div className="col-6" />
          </div>

          <SelectPartnerModal />
        </form>
      </Context.Provider>
    </div>
  )
}

export default CouponsForm
